import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'
import proxyClient from '@/plugins/axios/proxyClient'

export default {
  /**
   *
   * @param {
   *   loanType: 'normal', 옵션
   *   repaymentPeriodInDays: 5, 30, 180  // 옵션
   * } query
   * @returns
   */
  getLoansOffersCurrent(query = {}) {
    return defaultClient.get(`/loans/offers/current/?${qs.stringify(query)}`)
  },
  postLoansOfferEarlyPayment() {
    return defaultClient.post('/loans/offers/early_payment/')
  },
  postLoansCreate(offerId) {
    return defaultClient.post('/loans/create/', {
      offer: offerId,
    })
  },
  getLoansExecuteFunding() {
    return defaultClient.get('/loans/execute-funding/')
  },
  getRepaymentsSimple(query) {
    return defaultClient.get(`/loans/repayments-simple?${qs.stringify(query)}`)
  },
  postLoan(offerId) {
    return defaultClient.post('/loans/create/', {
      offer: offerId,
    })
  },
  getLoans(query) {
    return defaultClient.get(`/loans/?${qs.stringify(query)}`)
  },
  getCurrentLoan() {
    return defaultClient.get('/loans/current/')
  },
  getLoansDetail(uuid) {
    return defaultClient.get(`/loans/${uuid}/`)
  },
  getLoansRepayments(uuid) {
    return defaultClient.get(`/loans/repayments/?${qs.stringify({ uuid })}`)
  },
  getLoansRegisterFunding(uuid) {
    return defaultClient.get(`/loans/register-funding/?${qs.stringify({ uuid })}`)
  },
  getInvestingAmount(uuid) {
    return defaultClient.get(`/loans/investing-amount/?${qs.stringify({ uuid })}`)
  },
  getCloseFunding(uuid) {
    return defaultClient.get(`/loans/close-funding/?${qs.stringify({ uuid })}`)
  },
  geExecuteFunding(uuid) {
    return defaultClient.get(`/loans/execute-funding/?${qs.stringify({ uuid })}`)
  },
  getLoanAvailableTime() {
    return defaultClient.get(`/loans/available/time/`)
  },

  /**
   * 대출 uuid 로 대출신청정보 조회
   * @param {*} uuid
   * @returns
   */
  getLoansRequestByLoan(uuid) {
    return proxyClient.get(`/loans/${uuid}/request`)
  },
}
